var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
import lightGallery from 'lightgallery';
import lgVideo from 'lightgallery/plugins/video';
import lgHash from 'lightgallery/plugins/hash';
export class Capsule extends Component {
    constructor() {
        super('Capsule', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $('.dynamic-gallery').on('click', (event, item) => __awaiter(this, void 0, void 0, function* () {
                location.hash = '#';
                event.preventDefault();
                var images = yield $.httpRequest({
                    url: '?gallery=' + $(item).data('id'),
                    dataType: 'json',
                });
                lightGallery(item.get(0), {
                    plugins: [lgHash],
                    dynamic: true,
                    dynamicEl: images,
                    speed: 500,
                    counter: false,
                    download: false,
                    hash: true,
                }).openGallery();
            }));
            $('.gallery-videos, .gallery-podcasts').each((gallery) => {
                lightGallery(gallery.get(0), {
                    plugins: [lgVideo, lgHash],
                    speed: 500,
                    counter: false,
                    download: false
                });
            });
            if (location.hash.search('item-') > 0) {
                const target = $(location.hash.replace('item-', 'capsule-item-'));
                if (target.data('type') == 'texts') {
                    setTimeout(() => {
                        $.scrollTo(target.position().y);
                    }, 1000);
                }
                else {
                    $(location.hash.replace('item-', 'capsule-item-')).trigger('click');
                }
            }
            $('body').on('click', '.lg-close', () => {
                setTimeout(() => {
                    location.hash = '#';
                }, 500);
            });
            this.success();
        });
    }
}
